import React from 'react';
import { NotificationItem as NotificationItemType } from '../notificationsTypes';
import styles from './NotificationItem.module.css';

interface NotificationItemProps {
  notification: NotificationItemType;
  onMarkAsRead?: (id: string) => void;
}

const TYPE_ICONS: Record<string, string> = {
  order: '📦',
  payment: '💳',
  delivery: '🚚',
  promotion: '🏷️',
  system: '⚙️',
};

export const NotificationItemComponent: React.FC<NotificationItemProps> = ({
  notification,
  onMarkAsRead,
}) => {
  return (
    <div
      className={`${styles.item} ${!notification.isRead ? styles.unread : ''}`}
      onClick={() => !notification.isRead && onMarkAsRead?.(notification.id)}
    >
      <div className={`${styles.icon} ${styles[notification.type]}`}>
        {TYPE_ICONS[notification.type] || '🔔'}
      </div>
      <div className={styles.content}>
        <div className={styles.header}>
          <span className={styles.title}>{notification.title}</span>
          <span className={styles.timestamp}>{notification.timestamp}</span>
        </div>
        <p className={styles.message}>{notification.message}</p>
      </div>
      {!notification.isRead && <div className={styles.unreadDot} />}
    </div>
  );
};
